<template>
  <!-- 更多页 -->
  <div class="productShow"
       id="swiper-con">
    <ul class="clearfix" :style="!showMargin && contentData.length && numss > 1 ? ('width:'+newWidth + 'px') : ''">
      <template v-if="showOrNot&&contentData.length">
        <li class="fl"
            v-for="(ite,ind) in contentData"
            @click.stop="handleDetail(ite)"
            draggable="true" @dragstart="dragss($event,ite)"
            @contextmenu="windowRightMenu($event,ite)"
            :style="(ind+1)% (showMargin ? 5 : numss ) == 0 ? 'margin-right:0':''"
            :key="ind">
          <a href="javascript:;">
            <special-offer :ite="ite.pData"></special-offer>
            <ZImage :value="ite.pictures.length?(ite.VideoCover ? ite.pictures[1] : ite.pictures[0]):''"
                    :error-src="require('../assets/image/images/default_media.png')" />
            <div class="li_hover"
                 @click.stop="handleDetail(ite,'newDetail')">
              <p class="li_hover_title">
                <span>{{ite.others[0].standardData?ite.others[0].standardData:'标签'}}</span>
                <span>{{ite.appName?ite.appName:''}}</span>
              </p>
              <div class="li_hover_conter">
                <div class="label-box"
                     v-if="ite.others">
                  <div class="label-set"
                       v-for="(tag,tin) in filterJCPrice(ite.tags)"
                       :key="tin">
                    <span>{{tag.standardName?tag.standardName+'：':''}}</span>{{allPrice(tag.standardEnName) ? formatPrice(tag.standardData) : tag.standardData}}
                  </div>
                </div>
              </div>
            </div>
            <img @click.stop.prevent="openVideo(ite.pictures[0],ite.others[0].standardData?ite.others[0].standardData:'标签')" v-show="ite.VideoCover" class="li_hover_img" src="../assets/image/images/wz_play.png" alt="">
          </a>
        </li>
      </template>
      <div class="prompt"
           v-if="showOrNot&&!contentData.length"
           @contextmenu.stop.prevent="">
        <span>抱歉，没有找到符合条件的商品</span>
        <span>建议修改筛选条件更新查找</span>
      </div>
      <div class="prompt"
           v-if="!showOrNot"></div>
    </ul>
    <!-- 分页器 -->
    <paging @handleCurrentChange="handleCurrentChange"
     @handleSizeChange="handleSizeChange"
      :pages="'30条/页'"
       :currentPage="currentPage"
       :totalPage="totalPage"
        :endPage="endPage"
         v-if="showOrNot&&contentData.length&&prompt"></paging>
  </div>
</template>
<script>
import Bus from '../bus.js'
import ZImage from "./ZImage.vue"
import paging from "./paging.vue"
import SpecialOffer from './specialOffer.vue'
export default {
  name: 'productShow',
  components: {
    ZImage,
    paging,
    SpecialOffer
  },
  props: {
    contentData: {
      type: Array,
      defaults: []
    },
    currentPage: {
      type: Number
    },
    totalPage: {
      type: Number
    },
    endPage: {
      type: Number
    },
    showOrNot: {
      type: Boolean
    },
    blockData: {
      type: Object
    },
    defaultBlockId:{
      type: String
    }
  },
  data () {
    return {
      defaults: ['在线直播', '抖变视界', '百家印象', '今日资讯', '百家文库', '中机知道', '操作培训', 'AI设备', 'ZJ同屏', '同屏体验'],
      //搜索没有数据时的标识
      prompt: false,
      currentPageNum: 1,
      numss: Math.floor(((document.documentElement.clientWidth || document.body.clientWidth - 16)/247))
    }
  },
  mounted () {
    this.prompt = true;
    window.onresize = () =>{
      // 根据可视区域的宽度判断需要几列,假设图片宽度为240px
      this.numss = Math.floor(((document.documentElement.clientWidth || document.body.clientWidth - 16)/247));
      if (this.numss < 1) {
        this.numss = 1;
      }else if (this.numss > 5){
        this.numss = 5;
      }
    }
  },
  computed:{
    showMargin(){
      return window.innerWidth>768  ? true : false
    },
    newWidth () {
      return this.numss*247 - 20;
    }
  },
  methods: {
    dragss(ev,items){
      
      var ipcRender,wzUrl = items&&items.contentWzUrl?items.contentWzUrl :items.contentDsfWzUrl;
      
      if (navigator.userAgent.indexOf('Electron') > -1) {
        ev.preventDefault();
        ipcRender = top.window.ipcRender ? top.window.ipcRender : top.window.require('electron').ipcRenderer;
        ipcRender.send('startdrag',{'id':items.contentId,'fileName':items.standAllName?items.standAllName + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr'):'','url': wzUrl ? wzUrl : location.origin + '/uoqid?appId='+ items.appId +'&blockId='+ items.blockId +'&contentId='+ items.contentId +'&dataType=' + (items.sign ?  items.sign : 1)});
      }else{
        var desk = items.standAllName?items.standAllName:items.others[0].standardData;
        var text = JSON.stringify({ title: desk, url: wzUrl });  //要保存的内容
        var blob = new Blob([text], { type: "text/plain" });
        var anchor = window.URL.createObjectURL(blob);  //要保存的链接
        // 设置为文件类型
        ev.dataTransfer.setData("DownloadURL", 'text/plain:' + desk + (window.location.href.indexOf('520ezj') > -1 ? '.zjs' : '.znr') + ':' + anchor);
        ev.dataTransfer.setData("deviceId", JSON.stringify({id:items.contentId,checkedItemId:items.contentId,env:location.hostname}));
      }
    },
    windowRightMenu(ev,item){
      window.$rightLeft = {
        left: '',
        center: {
          item: item,
          blockId: item.blockId,
          contentId: item.contentId,
          standardJson: item.tags
        },
        right: ''
      };
      window.$search = {};
      window.$defaultBlockId = this.defaultBlockId;
      window.$floorflowId = this.blockData ? this.blockData : {id:this.getQuery('floorFlowId'),flowEnName:this.getQuery('flowEnName')};
      window.$contentWzUrl = item.contentWzUrl ? item.contentWzUrl : item.contentDsfWzUrl;
      window.$releaseId = item.contentId ? item.contentId : '';
      window.$nodeId = item.nodeId;
      window.$dataType = item.sign;
      window.$blockId = item.blockId;
      window.$isYyz = parseInt(item.isYyz);
      window.$isBlock = '';
      window.outerName = item.others[0].standardData?item.others[0].standardData:'标签';
      if(this.$route.name == 'Next'){
        ev.stopPropagation();
        ev.preventDefault();
        Bus.$emit('windowRight', ev, item,this.blockData && this.blockData.flowEnName ? this.blockData.flowEnName : window.$floorflowId.flowEnName);
      }
    },
    handleSizeChange (page) {
      this.$emit('emitSize',page);
    },
    handleCurrentChange (val) {
      this.$emit('emitCurrent', val);
    },
    //跳转详情页
    handleDetail (ite) {
      this.$blockGetData.handleDetail(this, ite);
    },
    //寻找参数
    getQuery (name) {
      // 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      let r = window.location.search.substr(1).match(reg);//substr() 的参数指定的是子串的开始位置和长度
      if (r != null) {
        // 对参数值进行解码
        return decodeURI(r[2]);
      }
      return null;
    }
  }
}
</script>
<style>
</style>
<style lang="scss" scoped>

.prompt {
  border: 1px solid #dddddd;
  margin-top: 20px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.prompt span:nth-child(1) {
  font-size: 18px;
  color: #333333;
}
.prompt span:nth-child(2) {
  font-size: 14px;
  color: #666666;
  margin-top: 30px;
}
.productShow {
  width: 100%;
  height: auto;
  ul{
    margin: 0 auto;
  }
}
.productShow:hover .arrow-left,
.productShow:hover .arrow-right {
  display: block;
}
.productShow ul {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
ul li {
  display: block;
  font-size: 0;
  // line-height: 108px;
  background: #fafafa;
  position: relative;
  width: 226.4px;
  height: 326px;
  margin-right: 17px;
  margin-top: 16px;
  a{
    width: 100%;
    height: 100%;
    // display: block;
  }
  .li_hover_img{
    position: absolute;
    bottom: 48px;
    right: 0;
    width: 26px;
    height: 20px;
  }
}

.li_hover {
  transition: all 0.2s linear;
  width: calc(100% - 20px);
  /* // height: 100%; */
  position: absolute;
  left: 0;
  bottom: 0;
  /* // bottom: -285px; */
  background: rgba(0, 0, 0, 0.6);
  padding: 0 10px;
  &:hover {
    transition: all 0.2s linear;
    height: 100%;
    .li_hover_title {
      padding-top:6px;
    }
    .li_hover_conter {
      display: block;
    }
  }
  &:hover ~ .li_hover_img{
    display: none;
  }
}
.li_hover_title {
  display:flex;
  flex-direction:column;
  width: 100%;
  margin: 0;
  font-size: 16px;
  color: #fff;
  height: 48px;
  span{
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  span:nth-child(1){
    font-size:14px;
    color:rgb(255,255,255);
    padding-top:5px;
  }
  span:nth-child(2){
    font-size:12px;
    color:rgb(170,170,170);
    padding-top:1px;
  }
}
.li_hover_conter {
  border-top: 1px dashed #bbbbbb;
  display: none;
  text-align: left;
  font-size: 14px;
  line-height: 20px;
  /* margin: 10px 0; */
  color: #fff;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 7;
  height: calc(100% - 59px);
  width: 168px;
  overflow: auto;
}
.label-box {
  width: 100%;
}
.label-set {
  height: 26px;
  line-height: 26px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen   and (max-width: 510px) {
    #swiper-con {
      ul{
        width: 100%;
        li{
          width: 100%;
          img{
            object-fit: cover !important;
          }
        }
      }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/productShow.vue